export const MODULE = 'BILLING_BTAX';

export const UPLOAD = `${MODULE}/upload`;
export const LIST = `${MODULE}/list`;

export const MODULE_TYPE = [
  {
    label: 'ALL',
    value: '',
  },
  {
    label: 'Real Property Tax',
    value: 'Real Property Tax (RPTAX)',
  },
  {
    label: 'Official Violation Receipt System',
    value: 'OVR - Ordinance Violation Receipt System',
  },
  { label: 'Business Tax', value: 'Business Tax (BTAX)' },
  {
    label: 'Community Tax Certificate',
    value: 'Community Tax Certificate CTC / CEDULA',
  },
  { label: 'Birth Certificate', value: 'Local Civil Registry' },
  {
    label: 'Occupational/Health Permits',
    value: 'Occupational Permit / Health Certificate',
  },
  {
    label: 'GO! BPLS',
    value: 'GO! BPLS',
  },
  {
    label: 'E-Boss',
    value: 'Business Permit Application (NEW & RENEWAL)',
  },
  {
    label: 'Notice of Violation',
    value: 'NOV - Notice of Violation',
  },
];

export const STATUS_OPTIONS = [
  { label: 'ALL STATUS', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'APPROVED', value: 'APPROVED' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'PAID', value: 'PAID' },
  { label: 'PENDING LAB TEST', value: 'PENDING LAB TEST' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
  { label: 'FOR DELIVERY', value: 'FOR DELIVERY' },
];

export const PAYMENT_STATUS = [
  { label: 'NULL', value: '' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'PAID', value: 'PAID' },
];

export const PAYMENT_STATUS_2 = [
  { label: 'ALL', value: '' },
  { label: 'UNPAID', value: 0 },
  { label: 'PAID', value: 1 },
];

export const BPLS_TRANSACTION_TYPE = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW'},
  { label: 'RENEWAL', value: 'RENEWAL',},
  { label: 'QUARTERLY', value: 'QUARTERLY' },
  { label: 'DELINQUENT',value: 'DELINQUENT',},
  { label: 'CHANGE', value: 'CHANGE' },
  { label: 'RETIREMENT', value: 'RETIREMENT' },
];

export const EBOSS_TRANSACTION_TYPE = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW'},
  { label: 'RENEWAL', value: 'RENEWAL',},
  { label: 'QUARTERLY', value: 'QUARTERLY' },
  { label: 'DELINQUENT',value: 'DELINQUENT',},
];

export const RPTS_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'TAX PAYMENT', value: 'TAX PAYMENT' },
];

export const BTAX_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'TAX PAYMENT', value: 'TAX PAYMENT' },
];

export const PSA_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'BIRTH CERTIFICATE', value: 'BIRTH CERTIFICATE' },
  { label: 'MARRIAGE CERTIFICATE', value: 'MARRIAGE CERTIFICATE' },
  { label: 'DEATH CERTIFICATE', value: 'DEATH CERTIFICATE' },
];

export const CDL_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'INDIVIDUAL', value: 'INDIVIDUAL' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];

export const OHP_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'NEW', value: 'NEW' },
  { label: 'RENEWAL', value: 'RENEWAL' },
];

export const OVRS_TRANSACTIONS = [
  { label: 'ALL', value: '' },
  { label: 'OVR PAYMENT', value: 'OVR PAYMENT' },
];

export const NOV_TRANSACTIONS = [{ label: 'ALL', value: '' }];
